import Vue from 'vue'
import VueRouter from 'vue-router'

// 移动端

// 首页（移动端）
import mIndex from '../views/mobile/mIndex.vue'

// 联系我们（移动端）
import mContact from '../views/mobile/mContact.vue'

// 导航（移动端）
import mNav from '../views/mobile/mNav.vue'

// 法律（移动端）
import mLaw from '../views/mobile/mLaw.vue'

// 工程项目（移动端）
import mProject from '../views/mobile/mProject.vue'

// 项目汇报视频、PPT材料服务（移动端）
import mItems from '../views/mobile/mItems.vue'

// 项目信息化建设（移动端）
import mInformation from '../views/mobile/mInformation.vue'

// 关于我们（移动端）
import mAboutour from '../views/mobile/mAboutour.vue'

// 专项培训（移动端）
import mTrain from '../views/mobile/mTrain.vue'

// 新闻中心（移动端）
import mNews from '../views/mobile/mNews.vue'

// 新闻详情（移动端）
import mNewsDetail from '../views/mobile/mNewsDetail.vue'

// 双重（移动端）
import mDouble from '../views/mobile/mDouble.vue'

// 营业执照（移动端）
import mCopyright from '../views/mobile/mCopyright'

Vue.use(VueRouter)

const VueRouterPush =VueRouter.prototype.push
VueRouter.prototype.push = function push (to) {
  return VueRouterPush.call(this, to).catch(err => err)
}

const routes = [
  {
    path: '/',
    name: 'index',
    component: () => import('@/views/index')
  },
  // {
  //   path: '/index',
  //   name: 'index',
  //   component: index
  // },
  {
    path: '/news',
    name: 'news',
    component: () => import('@/views/news')
  },
  {
    path: '/serve',
    name: 'serve',
    component: () => import('@/views/serve')
  },
  {
    path: '/project',
    name: 'project',
    component: () => import('@/views/project')
  },
  {
    path: '/items',
    name: 'items',
    component: () => import('@/views/items')
  },
  {
    path: '/law',
    name: 'law',
    component: () => import('@/views/law')
  },
  {
    path: '/information',
    name: 'information',
    component: () => import('@/views/information')
  },
  {
    path: '/train',
    name: 'train',
    component: () => import('@/views/train')
  },
  {
    path: '/double',
    name: 'double',
    component: () => import('@/views/double')
  },
  {
    path: '/aboutour',
    name: 'aboutour',
    component: () => import('@/views/aboutour')
  },
  {
    path: '/serveMsg',
    name: 'serveMsg',
    component: () => import('@/views/serveMsg')
  },
  {
    path: '/newsDetial',
    name: 'newsDetial',
    component: () => import('@/views/newsDetial')
  },
  {
    path: '/copyright',
    name: 'copyright',
    component: () => import('@/views/copyright')
  },






  {
    path: '/mIndex',
    name: 'mIndex',
    component: () => import('../views/mobile/mIndex')
  },
  {
    path: '/mContact',
    name: 'mContact',
    component: () => import('../views/mobile/mContact')
  },
  {
    path: '/mNav',
    name: 'mNav',
    component: () => import('../views/mobile/mNav')
  },
  {
    path: '/mLaw',
    name: 'mLaw',
    component: () => import('../views/mobile/mLaw')
  },
  {
    path: '/mProject',
    name: 'mProject',
    component: () => import('../views/mobile/mProject')
  },
  {
    path: '/mItems',
    name: 'mItems',
    component: () => import('../views/mobile/mItems')
  },
  {
    path: '/mInformation',
    name: 'mInformation',
    component: () => import('../views/mobile/mInformation')
  },
  {
    path: '/mAboutour',
    name: 'mAboutour',
    component: () => import('../views/mobile/mAboutour')
  },
  {
    path: '/mTrain',
    name: 'mTrain',
    component: () => import('../views/mobile/mTrain')
  },
  {
    path: '/mNews',
    name: 'mNews',
    component: () => import('../views/mobile/mNews')
  },
  {
    path: '/mNewsDetail',
    name: 'mNewsDetail',
    component: () => import('../views/mobile/mNewsDetail')
  },
  {
    path: '/mDouble',
    name: 'mDouble',
    component: () => import('../views/mobile/mDouble')
  },
  {
    path: '/mCopyright',
    name: 'mCopyright',
    component: () => import('../views/mobile/mCopyright')
  },
]

const router = new VueRouter({
  scrollBehavior(to,from,saveTop){ if(saveTop){ return saveTop; }else{ return {x:0,y:0} } },
  routes
})

const originalPush = router.push
   router.push = function push(location) {
   return originalPush.call(this, location).catch(err => err)
}
export default router
